import React, { useState } from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import ServiceButton from "../../../common/ServiceButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import logo1 from "../../../../assets/images/serviceImages/logo1.webp";
import logo2 from "../../../../assets/images/serviceImages/logo2.webp";
import logo3 from "../../../../assets/images/serviceImages/logo3.webp";
import logo4 from "../../../../assets/images/serviceImages/logo4.webp";
import logo5 from "../../../../assets/images/serviceImages/logo5.webp";
import logo6 from "../../../../assets/images/serviceImages/logo6.webp";
import socialMedia1 from "../../../../assets/images/serviceImages/socialMedia1.webp";
import socialMedia2 from "../../../../assets/images/serviceImages/socialMedia2.webp";
import socialMedia3 from "../../../../assets/images/serviceImages/socialMedia3.webp";
import socialMedia4 from "../../../../assets/images/serviceImages/socialMedia4.webp";
import socialMedia5 from "../../../../assets/images/serviceImages/socialMedia5.webp";
import print1 from "../../../../assets/images/serviceImages/print1.webp";
import print2 from "../../../../assets/images/serviceImages/print2.webp";
import print3 from "../../../../assets/images/serviceImages/print3.webp";
import print4 from "../../../../assets/images/serviceImages/print4.webp";
import print5 from "../../../../assets/images/serviceImages/print5.webp";
import print6 from "../../../../assets/images/serviceImages/print6.webp";

type ButtonType = "Graphic Design";


const GraphicDesigningWork = () => {
  const [selectedButton, setSelectedButton] =
    useState<ButtonType>("Graphic Design");
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <div className="flex justify-center gap-10 mb-5 sm:mb-10">
            <ServiceButton
              className={`${
                selectedButton === "Graphic Design" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("Graphic Design")}
            >
              Graphic Design
            </ServiceButton>
          </div>
          <div>
            {selectedButton === "Graphic Design" && (
              <div className="text-white">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  className="flex justify-center items-center"
                  pagination={{
                    type: "bullets",
                    el: ".pagination-progress",
                    clickable: true,
                  }}
                  breakpoints={{
                    640: {
                      autoplay: false,
                    },
                    768: {
                      autoplay: false,
                    },
                    1024: {
                      autoplay: true,
                    },
                  }}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  loop
                >
                  <SwiperSlide className="rounded-[16px]">
                    <>
                      <div className="hidden lg:grid lg:grid-cols-4 gap-10">
                        <img
                          src={print1}
                          alt=""
                          className="rounded-[30px] w-full lg:row-span-2"
                        />
                        <img
                          src={print2}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                        <img
                          src={print3}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                        <img
                          src={print4}
                          alt=""
                          className="rounded-[30px] w-full lg:row-span-2"
                        />
                        <img
                          src={print5}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                        <img
                          src={print6}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                      </div>
                      <div className="lg:hidden">
                        <Swiper
                          modules={[Navigation, Pagination]}
                          className="flex justify-center items-center"
                          pagination={{
                            type: "bullets",
                            el: ".pagination-progress1",
                            clickable: true,
                          }}
                          spaceBetween={20}
                          slidesPerView={1}
                          navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                          }}
                          loop
                        >
                          <SwiperSlide>
                            <img
                              src={print1}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print2}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print3}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print4}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print5}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print6}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                        </Swiper>
                        <div className="swiper-pagination pagination-progress1 w-full relative z-10"></div>
                      </div>
                    </>
                  </SwiperSlide>
                  <SwiperSlide className="rounded-[16px]">
                    <>
                      <div className="hidden lg:grid lg:grid-cols-4 gap-10">
                        <img
                          src={logo1}
                          className="rounded-[30px] lg:row-span-2 w-full"
                          alt=""
                        />
                        <img
                          src={logo2}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={logo3}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={logo6}
                          className="rounded-[30px] lg:row-span-2 w-full"
                          alt=""
                        />
                        <img
                          src={logo4}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={logo5}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                      </div>
                      <div className="lg:hidden">
                        <Swiper
                          modules={[Navigation, Pagination]}
                          className="flex justify-center items-center"
                          pagination={{
                            type: "bullets",
                            el: ".pagination-progress2",
                            clickable: true,
                          }}
                          spaceBetween={20}
                          slidesPerView={1}
                          navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                          }}
                          loop
                        >
                          <SwiperSlide>
                            <img
                              src={logo1}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo2}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo3}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo4}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo5}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo6}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                        </Swiper>
                        <div className="swiper-pagination pagination-progress2 w-full relative z-10"></div>
                      </div>
                    </>
                  </SwiperSlide>
                  <SwiperSlide className="rounded-[16px]">
                    <>
                      <div className="hidden lg:grid lg:grid-cols-4 gap-10">
                        <img
                          src={socialMedia1}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={socialMedia2}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={socialMedia3}
                          className="rounded-[30px] w-full h-full lg:col-span-2 lg:row-span-2"
                          alt=""
                        />
                        <img
                          src={socialMedia4}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={socialMedia5}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                      </div>
                      <div className="lg:hidden">
                        <Swiper
                          modules={[Navigation, Pagination]}
                          className="flex justify-center items-center"
                          pagination={{
                            type: "bullets",
                            el: ".pagination-progress3",
                            clickable: true,
                          }}
                          spaceBetween={20}
                          slidesPerView={1}
                          navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                          }}
                          loop
                        >
                          <SwiperSlide>
                            <img
                              src={socialMedia1}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia2}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia3}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia4}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia5}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                        </Swiper>
                        <div className="swiper-pagination pagination-progress3 w-full relative z-10"></div>
                      </div>
                    </>
                  </SwiperSlide>
                </Swiper>
                <div className="swiper-pagination pagination-progress w-full relative z-50 pt-5 sm:pb-10"></div>
              </div>
            )}
          </div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default GraphicDesigningWork;
